import React from 'react';

const PersistenceIndicator = ({ isVisible, message, type = 'success' }) => {
    if (!isVisible) return null;

    const bgColor = type === 'success' ? 'bg-green-500/10' : 'bg-red-500/10';
    const borderColor = type === 'success' ? 'border-green-500/30' : 'border-red-500/30';
    const textColor = type === 'success' ? 'text-green-400' : 'text-red-400';
    const iconColor = type === 'success' ? 'text-green-400' : 'text-red-400';

    return (
        <div className={`mb-4 p-4 ${bgColor} border ${borderColor} rounded-md animate-slide-in-bottom`}>
            <div className="flex">
                <div className="flex-shrink-0">
                    {type === 'success' ? (
                        <svg className={`h-5 w-5 ${iconColor}`} viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                        </svg>
                    ) : (
                        <svg className={`h-5 w-5 ${iconColor}`} viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                        </svg>
                    )}
                </div>
                <div className="ml-3">
                    <p className={`text-sm font-medium ${textColor}`}>
                        {message}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default PersistenceIndicator; 